module.exports = __webpack_public_path__ + "static/media/thumbnail.7abea456.jpg";